import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import Sidebar from 'components/atoms/GefMui/Sidebar/Sidebar';
import SidebarSection from 'components/atoms/GefMui/SidebarSection';
import { MPU_DISPLAY_LEAD_DETAIL } from 'features/common/acl/constants';
import fetch from 'features/common/fetch';
import { getLeadData } from 'features/views/leadDetail/selectors';
import RemainingTimeBarMui from 'pages/MarketPlace/components/RemainingTimeBarMui';

import SidebarClientInfo from './SidebarClientInfo';
import SidebarPolicyInfo from './SidebarPolicyInfo';

export const LeadDetailSidebar = () => {
	const leadData = useSelector(getLeadData);

	const remainingTimeData = {
		totalHours: leadData?.totalHours,
		remainingHours: leadData?.remainingHours,
		statusId: leadData?.statusId,
		finishTypeId: leadData?.finishTypeId,
		sla: leadData?.sla,
		isFromMarket: leadData?.isFromMarket,
	};

	return (
		<Sidebar>
			<AccessControl accessLevel={MPU_DISPLAY_LEAD_DETAIL}>
				<ComponentLoader fetchStorePath={fetch.constants.urls.leadDetail}>
					<Sidebar.Body spacing={2} sx={{ p: 3 }}>
						<SidebarSection heading={getLabelMessage('marketPlace:expiration')}>
							<RemainingTimeBarMui
								remainingTimeData={remainingTimeData}
								height={10}
								width="200px"
								fontSize={13}
							/>
						</SidebarSection>
						<SidebarPolicyInfo />
						<SidebarClientInfo />
					</Sidebar.Body>
				</ComponentLoader>
			</AccessControl>
		</Sidebar>
	);
};

LeadDetailSidebar.propTypes = {
	leadId: PropTypes.string,
};

export default LeadDetailSidebar;
